import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { CALENDLY_URL, EMAILS, SERVICES, whatsappUrl } from "../data/content";
import { LogoMark } from "./Nav";

export default function Footer() {
  return (
    <footer className="relative bg-forest text-paper grain overflow-hidden" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 lg:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-7">
            <p className="font-mono text-xs uppercase tracking-[0.25em] text-mint mb-6">Ready when you are</p>
            <a href={CALENDLY_URL} target="_blank" rel="noopener noreferrer" data-testid="footer-cta-link" className="group inline-block">
              <span className="font-serif text-5xl sm:text-7xl leading-none text-paper group-hover:text-mint transition-colors duration-300">
                Let's talk <span className="italic">finance.</span>
              </span>
              <span className="mt-6 inline-flex items-center gap-2 text-mint font-mono text-sm uppercase tracking-[0.2em]">
                Book a free 30-minute call <ArrowUpRight size={16} className="transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
              </span>
            </a>
          </div>
          <div className="lg:col-span-5 grid grid-cols-2 gap-8">
            <div>
              <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-paper/50 mb-5">Services</div>
              <ul className="space-y-3">
                {SERVICES.map((s) => (
                  <li key={s.slug}>
                    <Link to={`/services/${s.slug}`} className="text-sm text-paper/80 hover:text-mint transition-colors duration-200" data-testid={`footer-service-${s.slug}`}>
                      {s.title}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-paper/50 mb-5">Company</div>
              <ul className="space-y-3 text-sm text-paper/80">
                <li><Link to="/pricing" className="hover:text-mint transition-colors duration-200" data-testid="footer-pricing-link">Pricing</Link></li>
                <li><Link to="/#about" className="hover:text-mint transition-colors duration-200" data-testid="footer-about-link">About</Link></li>
                {EMAILS.map((em) => (
                  <li key={em}><a href={`mailto:${em}`} className="hover:text-mint transition-colors duration-200" data-testid={`footer-email-${em.split("@")[0]}`}>{em}</a></li>
                ))}
                <li>
                  <a href={whatsappUrl("Hello CFOSutra, I'd like to discuss your services.")} target="_blank" rel="noopener noreferrer" className="hover:text-mint transition-colors duration-200" data-testid="footer-whatsapp-link">
                    WhatsApp us
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="mt-20 pt-8 border-t border-paper/15 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
          <LogoMark dark />
          <p className="font-mono text-xs text-paper/50" data-testid="footer-copyright">© 2025 CFOSutra · Bengaluru, India · Serving US · UK · Singapore · UAE · India</p>
        </div>
      </div>
    </footer>
  );
}
